import clsx from 'clsx';

export default function Badge({
  label,
  small,
  tone = 'default',
}: {
  label: string;
  small?: boolean;
  tone?: 'default' | 'critical' | 'ghost';
}) {
  return (
    <div
      className={clsx(
        'btn-sm place-content-center',
        small ? 'text-xs' : 'text-sm',
        tone === 'critical' && 'text-red',
        tone === 'default' && 'text-darkGray',
        tone === 'ghost' && 'border border-orange !bg-white !text-orange',
      )}
    >
      {label}
    </div>
  );
}
